<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'About',
  data () {
    return {
      container: null,
      link: null,
      valvid: '',
      inter: '',
      page: 1,
      showMoreEnabled: true,
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  apollo: {
    page: {
      query: gql `query page($id: String!){
          page(id: $id){
            id page_containers{
              id container{titre id description titre medias{
                id image{url description} position video{
                  titre url description link
                }
              }} position
            }
          }
      }`,
      variables () {
        return {id: '0604efea-1686-4153-ad80-6d8131c7ad4f'}
      },
      fetchPolicy: 'cache-first',
      update: data => data.page,
    },
  },
  components: {
    BaseLayout,
  },
  methods: {
  },
}
</script>
<template lang="pug">
base-layout
  div.backgroundtexture
  //- div.backgroundimg
  div.about
    q-btn.fixed-bottom-right.animate-pop(v-back-to-top.animate='{offset: 500, duration: 200}', round='', color='negative', style='margin: 0 30px 30px 0')
      i.fa.fa-caret-up.fa-2x.white
    div
      div.bloctitre About The Team
        hr
        span.f3 behind Dreaming of a Jewish Christmas
      div.containerabout.flex(v-for='p in page.page_containers')
        div.imageabout
          img.fl(v-if='p.container.medias.length > 0', :src='p.container.medias[0].image.url')
          div.soustitreimageabout.fl {{p.container.titre}}
        div.contenuabout
          div.fr(v-html='p.container.description')

</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/*ANIMATION*/
.about{
  -moz-animation: fadeInUp 2s 1s;
  -webkit-animation: fadeInUp 2s 1s;
  animation: fadeInUp 2s 1s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
/*ANIMATION END*/

@media only screen and (min-width: 320px){
  .backgroundtexture{
  background-image: url("~@/assets/JWWC-SET-6_dark_light.jpg");
  background-size: cover;
  height: 100vh;
  width:100vw;
  z-index:-10;
  position:fixed;
  }

  .containerabout{
    width:80%;
    max-width:800px;
    margin: 20px auto 30px;
    border-bottom: 2px solid red;
    & .imageabout{
      width:100%;
      max-width:300px;
      display:block;
    }
    & .soustitreimageabout{
      color:white;
      font-family:Barlow Condensed;
      margin-top:10px;
      text-align: left;
      font-size:40px;
    }
    & .contenuabout{
      margin-bottom:40px;
      margin-top:20px;
      width:100%;
      line-height: 24px;
      text-align: left;
      color:white;
      font-family: Crimson Text;
      font-size:20px;
    }
  }
  .about{
  padding: 70px 35px 40px 35px;
    & .bloctitre {
      max-width:500px;
      font-family: Abril Fatface;
      font-size: 35px;
      margin: 0 auto 20px;
      /*background-color: red;*/
      color:white;
      padding: 20px 20px 20px 20px;
      border-style: double;
      border-width: 10px;
      border-color:white;
    }
    & .titresection{
      font-family:Marketdeco;
      color: red;
      font-size: 20px;
      margin-bottom: 30px;
      & span{
        border-style: solid;
        border-width: 3px 0 3px 0;
        border-color: red;
        padding: 5px 10px 5px 10px;
      }
    }
    & .logosection{
      padding-top: 25%;
    }
    & .menucontent{
      width: 100%;
      & .menustyle{
        width: 280px;
        border-style: solid;
        border-width: 0 0 1px 0;
        text-align: left !important;
        border-color: red;
        padding:10px;
        /*font-family:Marketdeco;*/
        color: red;
        font-size: 18px;
        margin: 0 auto;
        margin-bottom: 20px;
      }

      & a{
        color:darkred;
      }
    }
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {

.about{
padding: 70px 35px 40px 35px;

  & .titrecontent{
    font-family:Marketdeco;
    color: red;
    font-size: 20px;
    margin-bottom: 30px;
    margin-top: 50px;
    & span{
      border-style: solid;
      border-width: 3px 0 3px 0;
      border-color: red;
      padding: 5px 10px 5px 10px;
    }
  }
  & .logosection{
    float:left;
    width: 45%;
    padding-top: 18%;
    padding-left:10%;
    /*height: 100vh;*/
  }
  & .contentsection{
    float:left;
    width: 50%;
    margin-top: 8%;
    margin-left:5%;
    & .menucontent{
      width: 90%;
      /*margin-top: 10%;*/
    }
  }
}
}
@media only screen and (min-width: 768px){

  .containerabout{
    width:70%;
    margin: 20px auto 30px;
    border-bottom: 2px solid red;
    & .imageabout{
      width:30%;
      height:30%;
    }
    & .contenuabout{
      margin-bottom:40px;
      margin-top:0px;
      width:70%;
      padding: 0 0 0 30px;
    }
  }
  .about{
    & .logosection{
      padding-top: 18%;
    }
    & .contentsection{
      & .titresection{
        font-family:Marketdeco;
        color: red;
        font-size: 30px;
        margin-bottom: 50px;
        margin-top: 50px;
        & span{
          border-style: solid;
          border-width: 3px 0 3px 0;
          border-color: red;
          padding: 5px 10px 5px 10px;
        }
      }
      & .menucontent{
        width: 100%;
        & .menustyle{
          width: 500px;
          border-style: solid;
          border-width: 0 0 1px 0;
          text-align: left !important;
          border-color: red;
          padding:10px;
          /*font-family:Marketdeco;*/
          color: red;
          font-size: 26px;
          margin: 0 auto;
          margin-bottom: 20px;
        }
        & a{
          color:darkred;
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (orientation:landscape) {

  .about{
    & .logosection{
      padding-top: 10%;
    }
  }
}
@media only screen and (min-width: 961px){

  .about {
    & .bloctitre {
      font-family: Abril Fatface;
      font-size: 35px;
      width:500px;
      margin: 20px auto 20px;
      /*background-color: red;*/
      padding: 30px 30px 30px 30px;
      border-style: double;
      border-width: 10px;
      color:white;
      border-color:white;
    }
    & .blocdescription{
      padding: 0 20px 0 20px;
      width:700px;
      margin: 0 auto;
      & h1.blocdescription{
        color: white;
        font-family: Abril Fatface;
        font-size: 30px;
        margin-top: 10px;
        margin-bottom:10px;
      }
      & h1{
        color: white;
        font-family: Abril Fatface;
        font-size: 30px;
        /*margin-top: 40px;*/
        margin-bottom:10px;
        margin-top: 20px;
      }
      & h2 {
        font-family: Abril Fatface;
        font-size: 18px;
      }
      & strong{
        font-weight: bold;
      }
      & h3{
        font-size:18px !important;
        font-style: italic;
        font-weight: bold;
        border-bottom: 1px solid red;
        margin-bottom: 10px;
        padding-bottom: 10px;
      }
      & h4{
        font-size: 15px;
        margin:0 !important;
        }
      & h4 em{
        color:red;
        font-style: italic;
        font-size: 15px;
        line-height:20px;
      }
      & h5{
        Width:500px;
        margin: 0 auto;
        background-color:white;
        border-left: 4px red solid;
        padding:20px;
        font-style: italic;
        text-align: left;
        font-size:15px;
        line-height: 20px;
        box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2);
      }
      & p {
        font-size: 18px;
        color:white;
        margin-top: 22px;
        margin-bottom: 22px;
        line-height: 24px;
        text-align: justify;
        text-indent: 22px;
      }
      & p.exergue {
        text-indent:0px;
        font-size: 15px;
        font-style: italic;
        line-height: 20px;
        width:500px;
        padding: 20px 20px 20px 20px;
        border-left-width: 4px;
        border-left-color: red;
        background-color: white;
        border-left-style: solid;
        margin: 20px auto 20px;
      }
      & .serving{
        /*margin: 0;*/
        font-size: 20px;
        text-align: center!important;
      }
      & .time{
        /*margin: 0;*/
        font-size: 20px;
        text-align: center!important;
      }
      & .serving:before{
        font-family: FontAwesome;
        content: "\f0c0";
        color: red;
        margin-right: 8px;
        font-size: 24px;
      }
      & .time:before{
        font-family: FontAwesome;
        content: "\f017";
        color: red;
        margin-right: 8px;
        font-size: 24px;
      }

      & ul {
        color: white;
        list-style-type: disc;
        text-align: left;
        font-size: 18px;
        margin-top: 20px;
        width: 100%;
      }
      & ul li {
        margin: 0 0 5px;
        text-align: left;
        line-height: 22px;
      }
      & ol {
        list-style-type: decimal;
        text-align: left;
        font-size: 18px;
        margin-top: 20px;
        width: 100%;
      }
      & ol li {
        color:white;
        margin: 0 0 20px 0;
        text-align: left;
        line-height: 25px;
      }
      & ol li:before{
        font-weight: bold;
        display: inline-block;
        color:red;
      }
      & a {
        color: #42b983;
      }
      & .soustitre{
        & p {
          margin: 5px 0 10px 10%;
          font-size: 15px;
          line-height: 18px;
          text-align: left;
          font-style:italic;
        }
        & p em {
          font-size: 15px;
          font-style: italic;
          line-height: 18px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// About.vue?0a0ddfd0